export default __webpack_public_path__ + "static/media/faithtalk_logo.297f1379.png";